import { GiSettingsKnobs } from "react-icons/gi";
import css from "./InfoSettingsVisibility.module.css";
import { useState, useEffect, useRef } from "react";
import clsx from "clsx";
import { useSelector, useDispatch } from "react-redux";
import Tooltip from "../Tooltip/Tooltip.jsx";
import useTooltip from "../../../utils/useTooltip.jsx";

const InfoSettingsVisibility = ({
  selectVisibility,
  toggleVisibilityAction,
  labelNames,
  className,
  viewMode,
  carsOpen,
}) => {
  const [settingsIsOpen, setSettingsIsOpen] = useState(false);
  const popoverRef = useRef(null);
  const dispatch = useDispatch();

  const {
    tooltipPosition,
    isTooltipVisible,
    handleMouseEnter,
    handleMouseMove,
    handleMouseLeave,
    handleClick,
  } = useTooltip();

  const visibility = useSelector(selectVisibility);

  const toggleSettings = () => {
    setSettingsIsOpen(prev => !prev);
  };

  const handleToggle = key => {
    dispatch(toggleVisibilityAction({ key }));
  };

  useEffect(() => {
    const handleClickOutside = event => {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        setSettingsIsOpen(false);
      }
    };

    if (settingsIsOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [settingsIsOpen]);

  //  Умова приховати два ключі в режимі списку в модалці DayCarsModal
  const filteredVisibility = Object.entries(visibility).filter(([key]) => {
    if (viewMode === "list") {
      return key !== "phoneNumber" && key !== "prePayment";
    }
    return true;
  });
  const filteredLabelNames = Object.entries(labelNames).filter(([key]) => {
    if (viewMode === "list") {
      return key !== "phoneNumber" && key !== "prePayment";
    }
    return true;
  });

  return (
    <div
      className={`${css.btnSettingsContainer} ${carsOpen ? css.btnSettingsContainerExpanded : ""}`}
      ref={popoverRef}
      data-tour-carsinwork="step-7"
      data-tour-carslist="step-4"
      data-tour-inworkgi="step-8"
    >
      <button
        className={css.btnSettings}
        onClick={() => {
          (toggleSettings(), handleClick());
        }}
        onMouseEnter={handleMouseEnter}
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
      >
        <GiSettingsKnobs className={css.iconSettings} />
        {isTooltipVisible && (
          <Tooltip
            isVisible={isTooltipVisible}
            position={tooltipPosition}
            text="Налаштування видимості"
          />
        )}
      </button>
      {settingsIsOpen && (
        <div className={clsx(css.settingsContainer, className)}>
          {filteredVisibility.map(([key, value]) => (
            <div className={css.switchItem} key={key}>
              <label className={css.label} htmlFor={key}>
                {filteredLabelNames.find(
                  ([labelKey]) => labelKey === key
                )?.[1] || key}
              </label>
              <label className={css.toggleSwitch}>
                <input
                  type="checkbox"
                  id={key}
                  checked={value}
                  onChange={() => handleToggle(key)}
                />
                <span className={css.slider}></span>
              </label>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default InfoSettingsVisibility;
